<!--
 * @Autor: lianxiben
 * @Date: 2023-02-17 15:35:36
 * @LastEditors: lianxiben
 * @LastEditTime: 2023-08-14 20:38:37
-->
<template>
  <div class="page-container ">
    <div class="home-page" id="ActiveIframe">
    <!-- 顶部栏 -->
    <div class="top-container">
      <div class="icon"></div>
      <div class="top-title">
        <div class="top-title-fir">提灯与地下城</div>
        <div class="top-title-sec"  v-if="!list.account">刷得爽的地牢养宠游戏</div>
        <div class="top-title-sec" v-if="list.account">{{  list.account}}</div>
      </div>

      <div class="btn-list">
        <div class="web-btn" @click="goWeb()"></div>
        <div class="login-btn" v-if="!list.is_login" @click="showLogin()"></div>
        <div class="loginout-btn" v-if="list.is_login" @click="loginOut()"></div>
      </div>
    </div>

    <div class="back" @click="back()"></div>
    <div class="ruler" @click="shareShow = true"></div>
    <div class="logo-container">
      <div class="small"></div>
      <div class="big"></div>
    </div>
    <div class="firework-container">
      <div class="firework-fir"></div>
      <div class="firework-sec"></div>
      <div class="firework-thr"></div>
      <div class="firework-four"></div>
    </div>
    <!-- <div class="ani"></div> -->
    <div class="jl-container">
      <div class="new" @click="getJl(2)">
        <!-- <div class="new-bgc">
          <div class="new-ani"></div>
        </div> -->
        <div class="get" v-if="list && list.is_new_send"></div>
      </div>
      <div class="old" @click="getJl(1)">
        <div class="get"  v-if="list && list.is_old_send"></div>
      </div>
    </div>
    <div class="bot-btn" v-if="list.is_book == false" @click="bookShow()"></div>

    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin' @loginSuccess="loginSuccess"  :gameName="gameName" :downloadUrl="downloadUrl"
      :loginTypes="loginTypes" channelTips="角色ID可在游戏中—蜗牛属性—蜗牛信息查看"></Login>
    <!-- 预约规则弹窗 -->
    <div class="help-share-wrap popup_wrap" v-if="shareShow" @click="shareShow = false">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="yygz popup_wrap-box" v-show="shareShow">
        </div>
      </transition>
    </div>
    <!-- 预约成功弹窗 -->
    <div class="help-share-wrap popup_wrap" v-if="bookPopup" >
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="book-popup popup_wrap_box" v-show="bookPopup">
          <div class="click-btn" @click="closeBookPopup()"></div>
        </div>
      </transition>
    </div>
    <!-- 领取成功 -->
    <div class="help-share-wrap popup_wrap" v-if="jlPopup">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="jl-get-popup popup_wrap_box" v-show="jlPopup">
          <div class="click-btn" @click="closeJlPopup()"></div>
        </div>
      </transition>
    </div>
    <!-- 无角色 -->
    <div class="help-share-wrap popup_wrap" v-if="noGamePopup" >
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="game-popup popup_wrap_box" v-if="noGamePopup && clickType ==2">
          <div class="click-btn" @click="closeGamePopup()"></div>
        </div>
        <div class="game-popup-old popup_wrap_box" v-if="noGamePopup && clickType ==1">
          <div class="click-btn"  @click="closeGamePopup()"></div>
        </div>
      </transition>
    </div>
  </div>
  <Footer :gameName="gameName"/>
  </div>
</template>
<script>
import Login from '@/components/login';
import Footer from '@/components/Footer';
import { mapState, mapMutations, mapActions } from 'vuex';
import { init, book, packages, destroy } from '../api';
import { Toast } from 'mint-ui';
import { buriedLogger } from '@/utils/utils';
export default {
  components: {
    Login,
    Footer
  },
  data: function () {
    return {
      shareShow: false,
      bookPopup: false,
      loginTypes: ['sms', 'password'],
      downloadUrl: 'https://tideng.qingcigame.com/leading/',
      gameName: 'tideng',
      list: {},
      jlPopup: false,
      noGamePopup: false,
      clickType: 0,
      gameName:'tideng',
      record:""
    };
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowOs',
      'isShowLogin'
    ])
  },
  mounted () {
    this.$nextTick(i => {
      let pageInfo = this.getWindowConfig()
      document.getElementById('ActiveIframe').style.height = (pageInfo.pageHeight - 46) + 'px'
      // document.getElementById('frameContainer').style.height = (pageInfo.pageHeight - 46) + 'px'
    })
  },
  created(){
    const  bl = buriedLogger('tideng','提灯周年庆_预约页')
    this.record = bl
    document.title = '长虹贯日、预约庆典'
    this.initList();
    this.setShare({
      title: '长虹贯日，预约庆典',
      desc: '提灯二周年啦！预约周年新区，得丰厚道具奖励~',
      imgUrl: 'https://download4.qcplay.com/tideng/active/anniversary_share_image_m.jpg'
    });
  },
  methods: {
    back () {
      this.$router.push('/anniversaryCelebration/index');
    },
    // 弹出登录窗
    showLogin () {
      this.changeLoginPopup(true);
    },
    // 登录成功回传
    loginSuccess () {
      this.initList();
    },
    // 初始化
    initList () {
      init().then(res => {
        this.list = res.data;
      });
    },
    // 预约
    bookShow () {
      this.record.sum('提灯周年庆预约页_预约按钮点击')
      if (!this.list.is_login) {
        return this.showLogin();
      }
      book().then((res) => {
        if (res.code === 200) {
          this.bookPopup = true;
          this.initList();
        }
      });
    },
    // 领取奖励
    getJl (e) {
      if (!this.list.is_login) {
        return this.showLogin();
      }
      if (!this.list.is_book) {
        return Toast('请先预约~');
      }
      if (e === 1 && this.list.is_old_send === 0) {
        this.packageJl(e);
      }
      if (e === 2 && this.list.is_new_send === 0) {
        this.packageJl(e);
      }
    },
    // 领取奖励
    packageJl (e) {
      this.clickType = e;
      packages({
        type: e
      }).then((res) => {
        if (res.code === 200) {
          this.jlPopup = true;
          this.initList();
        }
        else if (res.code ===403) {
          this.noGamePopup = true
        }
        else {
          Toast(res.message);
        }
      });
    },
    // 注销
    loginOut () {
      destroy().then(() => {
        this.initList();
      });
    },
    // 前往官网
    goWeb () {
      window.location.href = 'https://tideng.qingcigame.com/leading/';
    },
    getWindowConfig() {
      let windowWidth = window.innerWidth;
      let windowHeight = window.innerHeight;
      if (typeof windowWidth !== 'number') {
        if (document.compatMode === 'CSS1Compat') {
          windowWidth = document.documentElement.clientWidth;
          windowHeight = document.documentElement.clientHeight;
        } else {
          windowWidth = document.body.clientWidth;
          windowHeight = window.body.clientHeight;
        }
      }
      return {
        windowWidth: windowWidth,
        windowHeight: windowHeight
      }
    },
    // 关闭预约成功弹窗
    closeBookPopup(){
      this.bookPopup = false;
      this.record.sum('提灯周年庆预约页_预约成功')
    },
    // 关闭奖励领取失败弹窗
    closeGamePopup() {
      this.noGamePopup = false;
      if(this.clickType == 2) {
        this.record.sum('提灯周年庆预约页_新区领取奖励失败')
      }
    },
    //关闭领取奖励成功弹窗
    closeJlPopup(){
      this.jlPopup = false;
      if(this.clickType == 1) {
        this.record.sum('提灯周年庆预约页_旧区领取奖励成功')
      }
      if(this.clickType == 2) {
        this.record.sum('提灯周年庆预约页_新区领取奖励成功')
      }
    },
    ...mapMutations([
      'changeLoginPopup',
      'changeOsPopup',
      'setInitActiveInfo',
      'setInitUserInfo',
      'setLogger'
    ]),
    ...mapActions([
      'setShare'
    ])
  }
};
</script>
<style lang="less" scoped>
@import url('./index.less');
</style>



// WEBPACK FOOTER //
// src/pages/tideng/anniversaryCelebration/appointment/index.vue